/**
 * Dev Guide Carousel
 * Handles prev/next navigation and video play/pause for exercise cards.
 */
(function () {
  /* ── Carousel navigation ── */
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function getScrollStep() {
      const card = track.querySelector('.dev-guide-carousel__card');
      if (!card) return 300;
      return card.offsetWidth + 16; // card width + gap-4
    }

    function updateButtons() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  });

  /* ── Video play / pause ── */
  document.querySelectorAll('[data-guide-card]').forEach((card) => {
    const video = card.querySelector('[data-guide-video]');
    const btn = card.querySelector('[data-guide-play]');
    if (!btn) return;

    const playIcon = btn.querySelector('.dev-guide-icon-play');
    const pauseIcon = btn.querySelector('.dev-guide-icon-pause');

    btn.addEventListener('click', () => {
      if (!video) return;

      if (video.paused) {
        // Pause all other videos first
        document.querySelectorAll('[data-guide-video]').forEach((v) => {
          if (v !== video && !v.paused) {
            v.pause();
            const otherCard = v.closest('[data-guide-card]');
            if (otherCard) {
              const op = otherCard.querySelector('.dev-guide-icon-play');
              const oq = otherCard.querySelector('.dev-guide-icon-pause');
              if (op) op.style.display = '';
              if (oq) oq.style.display = 'none';
            }
          }
        });

        video.play();
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = '';
      } else {
        video.pause();
        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      }
    });

    // Reset icons when video ends (even though loop is on, as a safeguard)
    if (video) {
      video.addEventListener('ended', () => {
        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      });
    }
  });
})();
